var j = jQuery.noConflict();
(function (j) {
"use strict";
  
/* meanmenu */
j('.main-menu nav').meanmenu({
     meanMenuContainer: '.mobile-menu',
     meanScreenWidth: "991"
 });

j(window).on('scroll',function() {
   var scroll = j(window).scrollTop();
   if (scroll < 300) {
    j("#header-sticky").removeClass("scroll-header");
   }else{
    j("#header-sticky").addClass("scroll-header");
   }
  });


  // Smooth scroll
            j(function() {
            j('a[href*="#"]:not([data-toggle="tab"])').on('click', function() {
             if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
                 var target = j(this.hash);
                 var headerH = '170' ;
                 target = target.length ? target : j('[name=' + this.hash.slice(1) + ']');
                 if (target.length) {
                     j('html, body').animate({
                         scrollTop: target.offset().top - headerH + "px"
                     }, 1000);
                     return false;
                 }
             }
           });
         });



/* testimonial-active */




// scrollToTop
j.scrollUp({
  scrollName: 'scrollUp', // Element ID
  topDistance: '300', // Distance from top before showing element (px)
  topSpeed: 300, // Speed back to top (ms)
  animation: 'fade', // Fade, slide, none
  animationInSpeed: 200, // Animation in speed (ms)
  animationOutSpeed: 200, // Animation out speed (ms)
  scrollText: 'UP', // Text for element
  activeOverlay: false, // Set CSS color to display scrollUp active point, e.g '#00FFFF'
});

// WOW active
//new WOW().init();


})(jQuery);